import { tvpil } from '../compat/tvpil';
import { createMissingCategoryError, createUserUnauthorizedError } from '../errors';

import { composeChannels } from './composeChannels';
import { fetchChannelsPersonalization } from './personalization/fetchChannelsPersonalization';
import { fetchChannelCollectionQuery, fetchEntitledChannelsQuery, fetchChannelsQuery } from './queries';
import { getChannelsSettings } from './settings';
import { createWrongChannelCategoryType } from './settings/errors';

export type FetchChannelsArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export async function fetchChannels({ referenceId, pageReferenceId }: FetchChannelsArgs) {
  if (!tvpil.userId) {
    throw createUserUnauthorizedError();
  }

  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    throw createMissingCategoryError();
  }

  const settings = getChannelsSettings(category);

  if (!settings) {
    throw createWrongChannelCategoryType();
  }

  const [channelAssetsData, entitledChannelsData, channelCollectionData, personalization] = await Promise.all([
    fetchChannelsQuery(),
    fetchEntitledChannelsQuery(),
    fetchChannelCollectionQuery({ settings }),
    fetchChannelsPersonalization({ referenceId, pageReferenceId }),
  ]);

  if (!channelCollectionData || !personalization) {
    return undefined;
  }

  const channels = composeChannels({
    channelAssetsMap: channelAssetsData.channelMap,
    channelCollection: channelCollectionData.collection,
    entitledChannels: entitledChannelsData,
    personalization,
    settings,
  });

  if (settings.limit) {
    return channels.slice(0, settings.limit);
  }

  return channels;
}
